import React from 'react';
import './Header.css';
import GameController from './GameController';

const Header = () => (
  <div className="Header">
    <GameController />
  </div>
);

export default Header;
